import { Form, Select } from 'antd';
import { InverterApi } from 'api/InverterApi';
import { useAppSelector } from 'app/hooks';
import { paramOption } from 'models';
import * as React from 'react';
import { selectInverterItemSidebar } from '../Sidebar/sidebarSlice';

export interface SelectFieldProps {
  item: any;
}

export default function SelectField(props: SelectFieldProps) {
  const { item } = props;
  const [isValue, setIsValue] = React.useState<string | null>(null);
  const inverterId = useAppSelector(selectInverterItemSidebar);

  React.useEffect(() => {
    if (item) {
      (async () => {
        const response: any = await InverterApi.fetchStatisticByDevice({
          id: inverterId,
          text: item.key,
        });
        setIsValue(response[item.key][0].value !== null ? response[item.key][0].value : '0');
      })();
    }
  }, [item]);

  const renderInPut = (item: any, value: string) => {
    return (
      <Form.Item
        name={item.key}
        label={item.label}
        initialValue={parseInt(value)}
        style={{
          width: '50%',
        }}
      >
        <Select>
          {item.option.map((x: paramOption) => {
            return (
              <Select.Option key={item.label} value={x.value}>
                {x.label}
              </Select.Option>
            );
          })}
        </Select>
      </Form.Item>
    );
  };
  return <>{isValue !== null && renderInPut(item, isValue)}</>;
}
